import { createChatRoom } from './createChatRoom';
import { fetchChatRooms } from './fetchChatRooms';
import { fetchMessages } from './fetchMessages';
import { markMessageAsUnread } from './markMessageAsUnread';
import { removeChatRoom } from './removeChatRoom';
import { searchMessages } from './searchMessages';
import { sendMessage } from './sendMessage';
import { setMarkRead } from './setMarkRead';
import { updateContactName } from './updateContactName';

export const chatRoomService = {
  createChatRoom,
  fetchChatRooms,
  fetchMessages,
  markMessageAsUnread,
  removeChatRoom,
  searchMessages,
  sendMessage,
  setMarkRead,
  updateContactName,
};
